import { buildDescription } from './descriptions';
// Mulberry32
function mulberry32(a) {
    return function () {
        var t = (a += 0x6d2b79f5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
var GRID_SIZE = 16;
var CANVAS_SIZE = 1080;
var HATCH_SIZE = 4;
var SPACING = 4;
var MARGIN = 56;
var CELL_SIZE = 52.5;
export var PALETTE_TYPES = ['Regular', 'Blue', 'Red', 'Special Monochrome Grey'];
var REGULAR_PALLETTE = ['Sapphire', 'Azure', 'Ruby', 'Sun', 'Black', 'White'];
var SPECIAL_BLUE_PALLETTE = ['Sapphire', 'Royal', 'Atlantic', 'Azure', 'Black', 'White'];
var SPECIAL_RED_PALLETTE = ['Bordeaux', 'Ruby', 'Mandarin', 'Sun', 'Black', 'White'];
var SPECIAL_MONOCHROME_PALLETTE = ['Platinum', 'Shale', 'Obsidian', 'Black', 'White'];
export var COLORS = [
    'Atlantic',
    'Azure',
    'Black',
    'Bordeaux',
    'Mandarin',
    'Obsidian',
    'Platinum',
    'Royal',
    'Ruby',
    'Sapphire',
    'Shale',
    'Sun',
    'White',
];
export var GRID_LAYOUTS = ['Left Linear', 'Wave Long', 'Wave Short', 'Right Linear'];
export var CELL_TYPES = ['Regular Horizontal', 'Regular Vertical', 'Oversized Horizontal', 'Oversized Vertical'];
export var MARGIN_OFFSETS = ['None', 'Left', 'Right', 'Top', 'Bottom'];
export function getPropertiesFromTokenId(tokenId) {
    var seed = Number(BigInt(tokenId) & BigInt(4294967295));
    var sequence = Number(BigInt(tokenId) >> BigInt(32));
    var specialPalette = ((BigInt(tokenId) >> BigInt(10)) & BigInt(1)) === BigInt(1);
    var rand = mulberry32(seed);
    var indexExclusions = [];
    var shuffleArray = function (array) {
        for (var i = array.length - 1; i > 0; --i) {
            var j = Math.floor(rand() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    };
    // Grid Layout is [1, 4]
    var gridLayout = GRID_LAYOUTS[Math.floor(rand() * 4)];
    // Cell type is [0, 3]
    var cellType = CELL_TYPES[Math.floor(rand() * 4)];
    var hasHatches = rand() < 0.25;
    var maxHatchCount = Math.floor(1 + rand() * 4); // Leave this here due to rand() consumption
    var paletteRand = rand();
    var palette = Math.floor(specialPalette ? 3 : paletteRand < 0.75 ? 0 : paletteRand < 0.875 ? 1 : 2);
    var startingColorArray = palette == 0
        ? REGULAR_PALLETTE
        : palette == 1
            ? SPECIAL_BLUE_PALLETTE
            : palette == 2
                ? SPECIAL_RED_PALLETTE
                : SPECIAL_MONOCHROME_PALLETTE;
    var colorArray = shuffleArray(startingColorArray.slice())
        .slice(0, 5)
        .reduce(function (accumulator, color, index, original) {
        var random = rand();
        var newColor = index == 0 && random < 0.03
            ? 'Black'
            : index == 0 && random < 0.25
                ? 'White'
                : index != 0 && random < 0.1
                    ? 'Black'
                    : index != 0 && random < 0.2
                        ? 'White'
                        : color;
        var previousColor = index > 0 ? accumulator[index - 1] : undefined;
        var nextColor = index < 4 ? original[index + 1] : undefined;
        accumulator.push(previousColor == newColor || newColor == nextColor ? color : newColor);
        return accumulator;
    }, []);
    // Index Angle Max is 1, or [360, 720] (if Wave layout), or [-720, 720] (if Center layout)
    var indexAngleMaxRand = rand();
    var indexAngleMax = gridLayout == 'Wave Long'
        ? 360 + Math.floor(indexAngleMaxRand * 360)
        : gridLayout == 'Wave Short'
            ? -720 + Math.floor(indexAngleMaxRand * 1440)
            : 0;
    var frequency = Math.floor((indexAngleMax * 100) / 360);
    // Minimum Grid Scale [0.2, 0.7] (scaled by 100)
    var gridScaleMin = Math.floor(20 + rand() * 51); // Leave this here due to rand() consumption
    // Margin Offset is ["None", "Left", "Right", "Top", "Bottom"]
    var marginOffsetRand = rand() * 10;
    var marginOffset = MARGIN_OFFSETS[Math.floor(marginOffsetRand < 6 ? 0 : marginOffsetRand - 5)];
    // Has Window is boolean
    var hasWindow = rand() < 0.5;
    var windowSizeRand = 400 + rand() * 201;
    var windowSize = hasWindow ? Math.floor(windowSizeRand) : 0;
    var getCellsInWindow = function (windowIndex) {
        var x = Math.floor(windowIndex / (GRID_SIZE + 1));
        var y = windowIndex % (GRID_SIZE + 1);
        var cellIndices = [];
        for (var xOffset = -4; xOffset <= 3; ++xOffset) {
            if (x + xOffset >= GRID_SIZE || x + xOffset < 0)
                continue;
            var deltaX = xOffset < 0 ? -1 - xOffset : xOffset;
            for (var yOffset = -4; yOffset <= 3; ++yOffset) {
                if (y + yOffset >= GRID_SIZE || y + yOffset < 0)
                    continue;
                var deltaY = yOffset < 0 ? -1 - yOffset : yOffset;
                if (Math.pow(deltaX, 2) + Math.pow(deltaY, 2) <= Math.pow(windowSize / 100 / 2, 2)) {
                    cellIndices.push((x + xOffset) * GRID_SIZE + (y + yOffset));
                }
            }
        }
        return cellIndices;
    };
    var getRandomIndexWithExclusion = function (gridSize, marginOffset) {
        if (marginOffset === void 0) { marginOffset = 'None'; }
        var value;
        do {
            var x = marginOffset === 'Left' ? 0 : marginOffset === 'Right' ? gridSize - 1 : Math.floor(rand() * gridSize);
            var y = marginOffset === 'Top' ? 0 : marginOffset === 'Bottom' ? gridSize - 1 : Math.floor(rand() * gridSize);
            value = x * gridSize + y;
        } while (indexExclusions.includes(value));
        return value;
    };
    var getRandomValidWindowPosition = function (gridSize) {
        var actualWindowSize = (windowSize / 100) * (CELL_SIZE + 2 * SPACING);
        var x, y, x1, y1;
        do {
            x = Math.floor(rand() * gridSize);
            y = Math.floor(rand() * gridSize);
            x1 = MARGIN + (CELL_SIZE + 2 * SPACING) * x;
            y1 = MARGIN + (CELL_SIZE + 2 * SPACING) * y;
        } while (x1 - actualWindowSize / 2 < MARGIN / 4 ||
            y1 - actualWindowSize / 2 < MARGIN / 4 ||
            x1 + actualWindowSize / 2 > CANVAS_SIZE - MARGIN / 4 ||
            y1 + actualWindowSize / 2 > CANVAS_SIZE - MARGIN / 4);
        return x * gridSize + y;
    };
    // Window Position Index is [0, 288]
    var windowPosition = hasWindow ? Math.floor(getRandomValidWindowPosition(GRID_SIZE + 1)) : -1;
    indexExclusions.push.apply(indexExclusions, getCellsInWindow(windowPosition));
    // Solid Count is [1, 4]
    var solidCount = 1 + Math.floor(rand() * 4);
    // Solid Position Index 1 through 4 is [0, 288]
    var solidPosition1 = solidCount >= 1 ? Math.floor(getRandomIndexWithExclusion(GRID_SIZE, marginOffset)) : -1;
    indexExclusions.push(solidPosition1);
    var solidPosition2 = solidCount >= 2 ? Math.floor(getRandomIndexWithExclusion(GRID_SIZE)) : -1;
    indexExclusions.push(solidPosition2);
    var solidPosition3 = solidCount >= 3 ? Math.floor(getRandomIndexWithExclusion(GRID_SIZE)) : -1;
    indexExclusions.push(solidPosition3);
    var solidPosition4 = solidCount >= 4 ? Math.floor(getRandomIndexWithExclusion(GRID_SIZE)) : -1;
    indexExclusions.push(solidPosition4);
    var solidPositions = [solidPosition1, solidPosition2, solidPosition3, solidPosition4]
        .filter(function (position) { return position >= 0; })
        .sort(function (a, b) { return a - b; });
    var solidsInMargin = solidPositions.reduce(function (solidsInMargin, solidPosition) {
        var isInMarginOffset = (Math.floor(solidPosition / GRID_SIZE) === 0 && marginOffset == 'Left') ||
            (Math.floor(solidPosition / GRID_SIZE) === GRID_SIZE - 1 && marginOffset == 'Right') ||
            (Math.floor(solidPosition % GRID_SIZE) === 0 && marginOffset == 'Top') ||
            (Math.floor(solidPosition % GRID_SIZE) === GRID_SIZE - 1 && marginOffset == 'Bottom');
        return isInMarginOffset ? solidsInMargin + 1 : solidsInMargin;
    }, 0);
    var properties = {
        sequence: sequence,
        gridLayout: gridLayout,
        cellType: cellType,
        palette: PALETTE_TYPES[palette],
        colors: colorArray,
        marginOffset: marginOffset,
        hasWindow: hasWindow,
        solidCount: solidCount,
        solidPositions: solidPositions,
        hasHatches: hasHatches,
        maxHatchCount: maxHatchCount,
        description: '',
    };
    if (['Wave Short', 'Wave Long'].includes(gridLayout))
        Object.assign(properties, { frequency: frequency });
    if (hasWindow)
        Object.assign(properties, { windowSize: windowSize, windowPosition: windowPosition });
    if (marginOffset !== 'None')
        Object.assign(properties, { solidsInMargin: solidsInMargin });
    properties.description = buildDescription(properties);
    return properties;
}
//# sourceMappingURL=properties.js.map